<div class="metadata-area">
  <appMetadataWidget [data]="data"></appMetadataWidget>
  <app-metadata-field [data]="data"></app-metadata-field>
  <div id="form" [formGroup]="form">
    <div class="metadata-block" fxLayout="row wrap">
      <div class="metadata-properties">
        <div class="metadata-key" for="label" title="{{ data.id }}">Label</div>
        <div class="metadata-input-block">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input tabindex="1" fxFlex="flex-grow" formControlName="heading" class="metadata-input-field" id="label" type="text"
            placeholder="{{ data.label }}" (change)="onChangeLabel($event)" />
        </div>
        <div *ngIf="form?.get('heading')?.hasError('maxlength')" class="error-msg">Max 30 characters are allowed</div>
      </div>
      <div class="metadata-properties">
        <div class="metadata-key" for="desc">Description</div>
        <div class="metadata-input-block">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input tabindex="1" fxFlex="flex-grow" class="metadata-input-field" formControlName="description" id="desc" type="text"
            (change)="onChangeDescription($event)" />
        </div>
        <div *ngIf="form?.get('description')?.hasError('maxlength')" class="error-msg">Max 100 characters are allowed
        </div>
      </div>
    </div>
    <div class="metadata-block" fxLayout="row wrap">
      <div class="metadata-properties">
        <label class="metadata-key" for="reqCheck">Radio Required:</label>
        <input tabindex="1" type="checkbox" formControlName="reqCheck" id="reqCheck" (change)="onChangeRequired($event)" />
      </div>
    </div>
    <div class="metadata-block" fxLayout="row wrap">
      <div class="metadata-properties" >
        <label class="metadata-key" for="otherFlag">Other Optional Field</label>
        <input tabindex="1" class="metadata-value" id="otherFlag" type="checkbox" formControlName="otherFlag"
          (change)="onChangeOtherFlag($event)" />
      </div>
    </div>
    <!-- Comments -->    
    <div class="metadata-block" fxLayout="row wrap">
      <div class="metadata-title">Comment</div>         
    </div>    
    <div class="metadata-block" fxLayout="row wrap">         
      <div class="metadata-properties">
        <div class="metadata-key" for="commentKey" title="{{ data.id }}">Key</div>
        <div class="metadata-input-block">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input tabindex="1" fxFlex="flex-grow" formControlName="commentKey" class="metadata-input-field" id="commentKey" type="text"
            placeholder="{{ data.commentKey }}" (change)="onChangeCommentKey($event)" />
        </div>
        <div *ngIf="form?.get('heading')?.hasError('maxlength')" class="error-msg">Max 30 characters are allowed</div>
      </div>
    </div>
    <div class="metadata-block" fxLayout="row wrap">
      <div class="metadata-properties" fxLayout="row wrap">
        <div class="metadata-key" >Comment Condition&nbsp;&nbsp;</div>
        <div class="custom-control custom-checkbox cursor-pointer" *ngFor="let item of commentFieldGroup; let i = index">
            <input class="cursor-pointer" type="checkbox" id={{item.label}} [checked]="item.checked" (change)="changeCommentStatus(item)"/>&nbsp;
            <label for={{item.label}} class="cursor-pointer">{{item.label}}&nbsp;&nbsp;</label>
        </div>
      </div>
    </div>
    <div class="metadata-block" fxLayout="row wrap">
      <div class="metadata-properties" fxLayout="row nowrap">
        <label class="metadata-key" for="otherFlag">Conditional Comment Optional</label>
        <input tabindex="1" class="metadata-value" id="commentFieldOnOptional" 
          type="checkbox" 
          formControlName="commentFieldOnOptional"
          (change)="onChangeCommentFieldOnOptional($event)" />
      </div>
    </div>
  </div>
  <!-- Options -->
  <div id="optionsBlock" class="metadata-block">
    <div class="metadata-title">Options</div>
    <div class="metadata-properties" fxLayout="row nowrap">
      <mat-label class="metadata-key">Add/Clear</mat-label>
      <button mat-icon-button tabindex="1" class="metadata-button" (click)="onAddNewOption()" title="Add">
        <mat-icon class="action-icon">add</mat-icon>
      </button>
      <button mat-icon-button tabindex="1" class="metadata-button" (click)="onClearAllOptions()" title="Clear">
        <mat-icon class="action-icon">delete</mat-icon>
      </button>
    </div>
    <div id="optionRadio" [formGroup]="optionRadio" class="metadata-option" fxLayout="row wrap"
      *ngFor="let optionRadio of getOptions()['controls']; let i = index;">
      <div class="metadata-properties" fxLayout="row nowrap">
        <div class="metadata-key">Label</div>
        <div class="metadata-input-block" fxLayout="row nowrap">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input tabindex="1" formControlName="label" type="text" placeholder="Option label"
            class="metadata-input-field metadata-option-label" (change)="onSaveOptions(i)" />
        </div>
        <div *ngIf="optionRadio?.get('label')?.hasError('required')" class="error-msg">* Required</div>
      </div>
      <div class="metadata-properties" fxLayout="row nowrap">
        <div class="metadata-key">Value</div>
        <div class="metadata-input-block" fxLayout="row nowrap">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input tabindex="1" formControlName="value" type="text" placeholder="Option value"
            class="metadata-input-field metadata-option-label" (change)="onSaveOptions(i)" />
        </div>
        <div *ngIf="optionRadio?.get('value')?.hasError('max')" class="error-msg">Max 3000 is allowed</div>
        <div *ngIf="optionRadio?.get('value')?.hasError('required')" class="error-msg">* Required</div>
      </div>
      <div class="metadata-properties" fxLayout="row nowrap">
        <div class="metadata-key">Selected</div>
        <input type="checkbox" formControlName="selected" placeholder="Selected" (change)="onSelectOption(i)" />
      </div>
      <div class="metadata-properties" fxLayout="row nowrap">
        <div class="metadata-key">Disabled</div>
        <input type="checkbox" formControlName="disabled" placeholder="Selected" (change)="onSaveOptions(i)" />
      </div>
      <mat-icon class="metadata-icon-button" (click)="onDeleteOption(i)">delete</mat-icon>
    </div>
    <div class="metadata-properties" fxLayout="row nowrap">
      <div *ngIf="errorMessage !== ''" class="error-msg">{{errorMessage}}</div>
      <div class="error-msg">{{errorMessage}}</div>
    </div>
  </div>

  <div>
    <appMetadataTemplate [primitive]="data" [template]="template" (modifiedJsonTemplate)="getModifiedTemplate($event)">
    </appMetadataTemplate>
  </div>
</div>